import React, { forwardRef } from "react";
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';
import { APP_ROUTES } from '../../utils/constant';
import url from '../../utils/url';
import UserImage from '../UserImage';
import UserReactionScope from '../UserReactionScope';
import { createName } from '../../utils/func';
import './index.scss';
const PostUser = forwardRef((props, ref) => {
  const { author, scope, msg_flg, reactionId, storyId, story, source, beforeScore, action, scopeInteractive = true, profileUsername, profileInteractive = true } = props;
  const Profile = profileInteractive ? Link : 'span';
  const profileProps = profileInteractive ? { to: url(`${APP_ROUTES.USER}/${author.user_name}`) } : {};
    return (
      <div ref={ref} className="userVote post-user" data-in-app-actor={props.telemetryActorId || undefined}>
        <Row className="post-user-row" wrap={false} align="middle">
          <Col className="align-left post-user-avatar" flex="48px">
            <Profile aria-label={createName(author)} {...profileProps}><UserImage picture={author.picture}/></Profile>
          </Col>
          <Col className="align-left post-user-details" flex="auto">
            <div className="post_user_data">
              <Profile {...profileProps} title={`${createName(author)} @${author.user_name}`}>
                <span className="post_user_name">{createName(author)}</span>
                <span className="post_user_acc">@{author.user_name}</span>
              </Profile>
            </div>
          </Col>
          {beforeScore && <Col className="post-user-before-score" flex="48px" data-no-swipe>{beforeScore}</Col>}
          <Col className="align-right post-user-score" flex="0 0 calc(100% / 7)">
          {action}
          { !action && storyId &&
            <UserReactionScope scope={scope} msg_flg={msg_flg} reactionId={reactionId} storyId={storyId} story={story} source={source} interactive={scopeInteractive} profileUsername={profileUsername} />
          }
          </Col>
        </Row>
      </div>
    )
});

export default PostUser;
